import React, { Component, ReactElement } from "react";
import { I8N, LocaleUtil } from "@eres/core";
import { WebFormFieldProps } from "./index";
import { readValue, writeValue } from "@eres/forms/Utils";
import { SpinnerLoader } from "@my-dld/components/SpinnerLoader";
import { DefaultProps } from "@eres/forms";

export interface Props<T> extends WebFormFieldProps<T[], string> {
	isLoading?: boolean;
	formatter?: ( item: T ) => string;
	inputClassName?: string;
	errorInputClass?: string;
}

interface ReqiredProps<T> {
	renderForm: ( inpPros: any ) => ReactElement;
	renderListItem: ( item: T, index: number ) => ReactElement;
}

interface State {
	isFocus: boolean;
}

type XProps<T> = Props<T> & ReqiredProps<T>

class MultiListInput<T> extends Component<XProps<T>, State> {
	static defaultProps: DefaultProps<XProps<any>> = {
		formatter: item => LocaleUtil.getLocalValue( item ),
		containerClassName: "form-group field-style select-control",
		inputClassName: "form-control",
		errorInputClass: "form-input-error is-invalid",
		errorClassName: "invalid-feedback invalid-feedback-x",
	};

	constructor( props: XProps<T> ) {
		super( props );
		this.state = {
			isFocus: false,
		};
	}


	render() {
		const {
			id, containerClassName, inputClassName, errorInputClass, labelClassName, label, disabled,
			required, error, errorClassName, isLoading,
		} = this.props;
		let v = readValue( this.props ) as T[];
		const inpProps = {
			id: id,
			className: inputClassName + ( error ? ` ${ errorInputClass }` : "" ),
			value: v,
			disabled: disabled,
			onFocus: this.onFocus,
			onBlur: this.onBlur,
		};
		return (
			<React.Fragment>
				<div className={ containerClassName }>
					{ label && <label className={ labelClassName } htmlFor={ id }><span>{ label }</span>
						{ required && <span className="asterisk">*</span> }

					</label>
					}
					{ isLoading && <span>
                            <span
	                            className={ "clearfix" }
	                            style={ { float: I8N.isRTL() ? "left" : "right" } }><SpinnerLoader
	                            extraClass={ "spinner-border-sm" }/></span>
                        </span>
					}
					<div className="row">
						{ v && Array.isArray( v ) && v.map( ( value, index ) => {
							return <div className="col-md-4" key={ index }>
								<div className={ "multi-list-item-container" }>
									<div className={ "flex-fill" }>
										{ this.props.renderListItem( value, index ) }
									</div>
									<button
										className={ "btn btn-grey" } onClick={ () => {
										this.onDelete( value );
									} }><i className="fa fa-trash" aria-hidden="true"/>
									</button>
								</div>
							</div>;
						} ) }
					</div>
					{ this.props.children }
					{ error && <div className={ errorClassName }>{ error }</div> }
					<div>
						{ this.props.renderForm( inpProps ) }
					</div>
				</div>
			</React.Fragment>
		);
	}

	onDelete = ( item: T ) => {
		let v = readValue( this.props ) as T[];
		if ( v ) {
			let newV = v.filter( x => x != item );
			writeValue( this.props, newV, () => {
				if ( this.props.onValueChange )
					this.props.onValueChange( newV );
			} );
		}
	};

	private onFocus = () => {
		this.setState( { isFocus: true } );
	};

	private onBlur = () => {
		this.setState( { isFocus: false } );
	};
}

export default MultiListInput;
